import React from 'react';
import { ServiceDetailPage } from './ServiceDetailPage';

export const Arquitectura: React.FC = () => {
  const serviceData = {
    title: 'Arquitectura',
    description: 'Nos destacamos por un enfoque vanguardista y capacidad para reinventar cada espacio a través de ideas innovadoras y creativas. Nuestro compromiso es crear ambientes únicos que no solo reflejen las últimas tendencias, sino que también se adapten a las necesidades y aspiraciones de nuestros clientes.',
    image: '/services/Ser_Int_Arqui.jpg',
    
    sections: [
      {
        title: 'Servicios',
        items: [
          'Proyectos ejecutivos',
          'Diseño de renders',
          'Remodelación y obras nuevas',
          'Proyectos de instalación',
          'Catálogo de materiales',
          'Presupuesto de obra',
        ]
      }
    ]

  };

  return <ServiceDetailPage {...serviceData} />;
};
